(function(){
  'use strict';

  var CATEGORY_KEYWORDS={
    'towel rails':['towel rail','towel bar'],
    'robe hooks':['robe hook'],
    'paper holders':['paper holder','toilet paper holder','toilet roll holder','paper roll holder'],
    'shelves':['shelf','shelves'],
    'soap dishes':['soap dish'],
    'handles':['handle'],
    'floor wastes':['floor waste','floor drain'],
    'bottle traps':['bottle trap'],
    'pop up wastes':['pop up waste','popup waste','pop-up waste'],
    'basin mixers':['basin mixer','basin tap'],
    'kitchen taps':['kitchen tap','kitchen mixer','sink mixer'],
    'shower tapware':['shower mixer','shower tap','diverter mixer'],
    'spouts':['spout'],
    'shower sets':['shower set'],
    'hand showers':['hand shower'],
    'shower heads':['shower head'],
    'shower arms':['shower arm'],
    'countertop basins':['countertop','above counter','abovecounter'],
    'undermount basins':['undermount'],
    'back to wall toilets':['back to wall','back-to-wall'],
    'toilet buttons':['button','flush plate','plate'],
    'toilet cisterns':['cistern'],
    'toilet pans':['toilet pan',' pan '],
    'toilet packages':['package'],
    'shaving cabinets':['shaving cabinet'],
    'fluted vanities':['fluted'],
    'pvc vanities':['pvc'],
    'granite sinks':['granite sink'],
    'stainless steel sinks':['stainless steel sink'],
    'laundry sinks':['laundry sink'],
    'washing machine stops':['washing machine stop'],
    'led mirrors':['led mirror'],
    'standard mirrors':['standard mirror']
  };

  function normalise(value){
    return String(value||'')
      .toLowerCase()
      .replace(/matt\b/g,'matte')
      .replace(/[^a-z0-9]+/g,' ')
      .replace(/\s+/g,' ')
      .trim();
  }

  function collectionHandle(){
    var match=location.pathname.match(/^\/collections\/([^/?#]+)/);
    return match?decodeURIComponent(match[1]):'';
  }

  function keywordsFor(label){
    var key=normalise(label);
    return CATEGORY_KEYWORDS[key]||[key];
  }

  function cardText(card){
    return normalise([
      card.getAttribute('data-nuvio-filter-tokens'),
      card.getAttribute('data-filter-tokens'),
      card.getAttribute('data-product-title'),
      card.getAttribute('data-variant-title'),
      card.textContent
    ].filter(Boolean).join(' | '));
  }

  function matchesCategory(card,keywords){
    if(!keywords||!keywords.length) return true;
    var haystack=' '+cardText(card)+' ';
    return keywords.some(function(keyword){
      var needle=normalise(keyword);
      return needle&&haystack.indexOf(needle)!==-1;
    });
  }

  function isVisible(card){
    return !card.classList.contains('is-hidden')
      && !card.classList.contains('is-nuvio-category-hidden')
      && !card.classList.contains('is-nuvio-exclusive-hidden')
      && card.getAttribute('data-nuvio-finish-match')!=='false';
  }

  function updateCount(root){
    var visible=Array.prototype.filter.call(root.querySelectorAll('.nv-vc-card'),isVisible).length;
    var count=root.querySelector('[data-nuvio-result-count]');
    if(count) count.textContent=visible+' '+(visible===1?'product':'products')+' shown';
    var empty=root.querySelector('[data-liveempty],.nv-vc-empty');
    if(empty) empty.classList.toggle('is-visible',visible===0);
  }

  function activeBuiltInValue(root){
    var active=root.querySelector('.nv-vc-filter.is-active');
    return normalise(active?active.getAttribute('data-filter-value'):'');
  }

  function enforceToiletExclusivity(root){
    if(collectionHandle()!=='toilet') return;
    var value=activeBuiltInValue(root);
    root.querySelectorAll('.nv-vc-card').forEach(function(card){
      var title=normalise(card.getAttribute('data-product-title')||card.textContent);
      var isPackage=title.indexOf('package')!==-1;
      var hide=isPackage&&value&&value.indexOf('package')===-1;
      card.classList.toggle('is-nuvio-exclusive-hidden',hide);
    });
  }

  function applyCategory(root){
    var raw=root.getAttribute('data-nuvio-category-filter')||'';
    var keywords=raw?raw.split('|').filter(Boolean):[];
    root.querySelectorAll('.nv-vc-card').forEach(function(card){
      card.classList.toggle('is-nuvio-category-hidden',!matchesCategory(card,keywords));
    });
    enforceToiletExclusivity(root);
    updateCount(root);
  }

  function scheduleApply(root){
    [0,80,260,700,1400].forEach(function(delay){
      setTimeout(function(){applyCategory(root);},delay);
    });
  }

  function categoryLinks(nav){
    if(!nav) return [];
    return Array.prototype.map.call(nav.querySelectorAll('.nuvio-category-link'),function(link){
      return {label:String(link.textContent||'').replace(/\s+/g,' ').trim(),href:link.getAttribute('href')||''};
    }).filter(function(item){return item.label;});
  }

  function existingFiltersAreCategories(root){
    return normalise(root.getAttribute('data-filter-match-field'))==='product title';
  }

  function ensureFilterSection(root){
    var section=root.querySelector('.nv-vc-filter-section');
    if(section) return section;
    section=document.createElement('div');
    section.className='nv-vc-filter-section nuvio-generated-filter-section';
    section.innerHTML='<div class="nv-vc-filter-heading">Filter by</div>';
    var header=root.querySelector('.nv-vc-header');
    if(header&&header.parentNode) header.insertAdjacentElement('afterend',section);
    else root.insertBefore(section,root.firstChild);
    return section;
  }

  function makeCategoryGroup(root,items){
    if(!items.length||root.querySelector('.nuvio-category-filter-group')) return;
    var section=ensureFilterSection(root);
    var group=document.createElement('div');
    group.className='nuvio-filter-subgroup nuvio-category-filter-group';
    group.innerHTML='<div class="nuvio-filter-subgroup__label">Categories</div><div class="nuvio-category-filterbar" role="group" aria-label="Filter by category"></div>';
    var bar=group.querySelector('.nuvio-category-filterbar');

    function addButton(label,keywords,isAll){
      var button=document.createElement('button');
      button.type='button';
      button.className='nuvio-category-filter'+(isAll?' is-active':'');
      button.textContent=label;
      button.setAttribute('aria-pressed',isAll?'true':'false');
      button.setAttribute('data-category-value',isAll?'':keywords.join('|'));
      button.addEventListener('click',function(){
        var wasActive=button.classList.contains('is-active');
        bar.querySelectorAll('.nuvio-category-filter').forEach(function(item){
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed','false');
        });
        if(isAll||wasActive){
          bar.querySelector('.nuvio-category-filter[data-category-value=""]').classList.add('is-active');
          bar.querySelector('.nuvio-category-filter[data-category-value=""]').setAttribute('aria-pressed','true');
          root.removeAttribute('data-nuvio-category-filter');
        }else{
          button.classList.add('is-active');
          button.setAttribute('aria-pressed','true');
          root.setAttribute('data-nuvio-category-filter',keywords.join('|'));
        }
        scheduleApply(root);
      });
      bar.appendChild(button);
    }

    addButton('All categories',[],true);
    items.forEach(function(item){addButton(item.label,keywordsFor(item.label),false);});

    var finishBar=section.querySelector('.nv-vc-filterbar,.nv-vc-filter-bar,.nv-vc-filters');
    if(finishBar){
      var finishGroup=document.createElement('div');
      finishGroup.className='nuvio-filter-subgroup nuvio-finish-filter-group';
      var finishLabel=document.createElement('div');
      finishLabel.className='nuvio-filter-subgroup__label';
      finishLabel.textContent='Finishes';
      finishBar.parentNode.insertBefore(finishGroup,finishBar);
      finishGroup.appendChild(finishLabel);
      finishGroup.appendChild(finishBar);
      section.insertBefore(group,finishGroup);
    }else{
      section.appendChild(group);
    }
  }

  function cleanLegacyNavs(){
    document.querySelectorAll('[data-nuvio-category-links],.nuvio-category-nav').forEach(function(nav){nav.remove();});
  }

  function bind(root,nav){
    if(!root) return;
    var items=categoryLinks(nav);

    if(!existingFiltersAreCategories(root)&&items.length){
      makeCategoryGroup(root,items);
    }

    if(nav) nav.remove();
    cleanLegacyNavs();

    if(root.getAttribute('data-nuvio-combined-bound')==='true'){
      scheduleApply(root);
      return;
    }
    root.setAttribute('data-nuvio-combined-bound','true');

    root.addEventListener('click',function(event){
      if(event.target.closest&&event.target.closest('.nv-vc-filter')) scheduleApply(root);
    });

    var grid=root.querySelector('.nv-vc-grid');
    if(grid&&window.MutationObserver){
      var timer=null;
      new MutationObserver(function(){
        clearTimeout(timer);
        timer=setTimeout(function(){applyCategory(root);},50);
      }).observe(grid,{childList:true,subtree:true,attributes:true,attributeFilter:['class','data-nuvio-filter-tokens','data-product-title','data-variant-title','data-nuvio-finish-match']});
    }

    applyCategory(root);
  }

  function boot(scope){
    var searchScope=scope||document;
    var roots=searchScope.querySelectorAll?searchScope.querySelectorAll('.nuvio-variant-collection'):[];
    if(!roots.length) roots=document.querySelectorAll('.nuvio-variant-collection');
    roots.forEach(function(root){
      var nav=document.querySelector('[data-nuvio-category-links]');
      bind(root,nav);
    });
    cleanLegacyNavs();
    setTimeout(function(){
      document.querySelectorAll('.nuvio-variant-collection').forEach(function(root){
        bind(root,document.querySelector('[data-nuvio-category-links]'));
      });
    },160);
  }

  var style=document.createElement('style');
  style.textContent='\n    .nuvio-variant-collection .nv-vc-card.is-nuvio-category-hidden,\n    .nuvio-variant-collection .nv-vc-card.is-nuvio-exclusive-hidden{display:none!important}\n  ';
  document.head.appendChild(style);

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();
